import React from "react";
import { CrossIcon } from "@aureskonnect/react-ui";
import { AvForm } from "availity-reactstrap-validation";
import { useTranslation } from "react-i18next";
import {
    CustomCardBody,
    CustomCardFooter,
    CustomCardHeader,
} from "@components/Common/CustomCardStyled";
import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

interface FormLayoutProps {
    title: string;
    onCancel: () => void;
    onValidate: () => void;
    isValidateDisabled: boolean;
    children: React.ReactNode;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    isModalOpened: boolean;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    isAddClicked: boolean;
    setIsAddClicked: Function;
    setEditedData: Function;
    formClassName?: string;
}

export default function FormLayout({
    title,
    onCancel,
    onValidate,
    isValidateDisabled,
    children,
    setDataIsUpdated,
    isModalOpened,
    setIsModalOpened,
    isAddClicked,
    setIsAddClicked,
    setEditedData,
    formClassName,
}: FormLayoutProps) {
    const { t } = useTranslation();

    return (
        <div
            data-testid="form-layout-container"
            style={{
                height: "63vh",
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                paddingBottom: "20px",
            }}
        >
            <AvForm
                className={formClassName}
                style={{ flex: 1, display: "flex", flexDirection: "column" }}
            >
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ height: "76px", flexShrink: 0 }}
                >
                    <h5 className="pt-3 dev_txt_FRtitleFormCurrency">
                        {title}
                    </h5>
                    <CrossIcon
                        data-testid="form-close-btn"
                        className="icon-close-notification__clz dev_icn_FRcloseForm"
                        height={13}
                        width={13}
                        onClick={onCancel}
                    />
                </CustomCardHeader>
                <CustomCardBody
                    className="pl-3 pr-5"
                    style={{
                        paddingBottom: "1rem",
                        flexGrow: 1,
                    }}
                >
                    {children}
                </CustomCardBody>
                <CustomCardFooter
                    className="p-8"
                    style={{
                        flexShrink: 0,
                        borderTop: "1px solid #dee2e6",
                    }}
                >
                    <CustomSecondaryColorButton
                        data-testid="form-cancel-btn"
                        outline
                        rounded
                        className="mr-2 dev_btn_FRcancel"
                        variant="light"
                        onClick={onCancel}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        data-testid="form-validate-btn"
                        rounded
                        variant="primary"
                        className="dev_btn_FRvalidate"
                        disabled={isValidateDisabled}
                        onClick={onValidate}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>

            <ConfirmationEditMessage
                setDataIsUpdated={setDataIsUpdated}
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                isAddClicked={isAddClicked}
                setIsAddClicked={setIsAddClicked}
                setEditedData={setEditedData}
            />
        </div>
    );
}
